<div class="case-explanation-container">
  <div *ngIf="loading" class="loading-indicator">
    Loading case explanation...
  </div>

  <div *ngIf="error" class="error-message">
    {{ error }}
  </div>

  <div *ngIf="!loading && !error && caseData">
    <div class="case-header">
      <h2>Case #{{ index}} - {{ caseData.specialty }} ({{ caseData.subSpecialty }})</h2>
      <p class="case-location">Location: {{ caseData.location }} | Duration: {{ caseData.duration }}</p>
    </div>

    <!-- Tab headers -->
    <div class="tab-header">
      <div class="tab-buttons">
        <button 
          [ngClass]="{'active': isActiveTab('approach')}" 
          (click)="setActiveTab('approach')">
          Approach
        </button>
        <button 
          [ngClass]="{'active': isActiveTab('scoring')}" 
          (click)="setActiveTab('scoring')">
          Scoring
        </button>
        <button 
          [ngClass]="{'active': isActiveTab('clockManagement')}" 
          (click)="setActiveTab('clockManagement')">
          Clock Management
        </button>
      </div>
    </div>

    <!-- Tab content -->
    <div class="tab-content">
      <!-- Approach Tab Content -->
      <div *ngIf="isActiveTab('approach')" class="approach-content">
        <h3>Case Approach</h3>
        <div class="explanation-text" [innerHTML]="getApproachContent()">
        </div>
      </div>

      <!-- Scoring Tab Content -->
      <div *ngIf="isActiveTab('scoring')" class="scoring-content">
        <h3>Scoring</h3>
        <div class="scoring-text" [innerHTML]="getScoringContent()">
        </div>
      </div>

      <!-- Clock Management Tab Content -->
      <div *ngIf="isActiveTab('clockManagement')" class="clock-management-content">
        <h3>Clock Management</h3>
        <div class="clock-management-text" [innerHTML]="getClockManagementContent()">
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="!loading && !error && !caseData" class="no-case-selected">
    <p>Please select a case from the Interactive Cases list to view its explanation.</p>
  </div>
</div>
